export default (path) => {
    let assignedPath;
    assignedPath = path ? path : window.location.pathname;
    return window.location.protocol + '//' + window.location.host + '/' + assignedPath;
};
